import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CourseUpload from "./pages/CourseUpload";
import ProtectedRoute from "./pages/ProtectedRoute";
import Home from "./pages/Home";
import CoursesPage from "./pages/CoursesPage";
import MyCourses from "./pages/MyCourses";
import CourseDetails from "./pages/CourseDetails";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Terms from "./pages/Terms";
import RefundPolicy from "./pages/RefundPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./ScrollToTop";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import FELLOWSHIP_COURSES from './pages/Fellowship_Courses';
import CERTIFICATE_COURSES from './pages/Certificate_Courses';
import ViewCourseDetails from "./pages/ViewCourseDetails";
import EditCourse from "./pages/EditCourse";


function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Courses" element={<CoursesPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/mycourses" element={<MyCourses />} />
        <Route path="/course/:id" element={<CourseDetails />} />
        <Route path="/viewcourse/:id" element={<ViewCourseDetails />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/blog" element={<Blog />} />




        <Route path="/Fellowship_Courses" element={<FELLOWSHIP_COURSES />} />
        <Route path="/Certificate_Courses" element={<CERTIFICATE_COURSES />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/course-upload"
          element={
            <ProtectedRoute role="admin">
              <CourseUpload />
            </ProtectedRoute>
          }
        />



        <Route path="/edit" element={<ProtectedRoute role="admin"><EditCourse /></ProtectedRoute>} />
      </Routes>



    </>


  );
}

export default App;
